export default __webpack_public_path__ + "static/media/header_bg_prize_uk.3483dfba.jpg";